const FILTERS = {
  status: 'Status',
  tags: 'Tags',
};

export default FILTERS;
